<style scoped>
.no-text-decoration {
  text-decoration: none;
}

a {
  cursor: pointer !important;
}
</style>

<template>
  <a
    :id="resolvedBtnId"
    :href="href"
    class="primary--text no-text-decoration"
    target="_blank"
    @click="$emit('click')"
  >
    {{ text }}
  </a>
</template>

<script>
export default {
  name: 'AnchorSimpleLink',
  props: {
    href: String,
    btnId: String,
    text: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    resolvedBtnId() {
      return this.btnId || `${String(this.text).toLowerCase().split(' ').join('-')}-btn`;
    },
  },
};
</script>
